// Transfrom attributes in events to user friendly labels
export const TRANSFORM_KEYS_TO_LABELS = {
  start_time: 'Start time',
  end_time: 'End time',
  stop_offers_for_worker_type: 'Stop offers',
  bookable_individually: 'Bookable individually',
  offer_to: 'Offer to',
  offer_to_syft: 'Offer to',
  desc: 'Job description',
  client_base_rate: 'Client Rate',
  worker_base_rate: 'Worker Rate',
  rate_card_id: 'Rate Card',
  workers_required: 'Workers required',
  agency_reported_demand_buffer: 'Agency demand buffer',
}

// Filter attributes what users required
export const FILTERED_DETAILS = [
  'start_time',
  'end_time',
  'bookable_individually',
  'skill_id',
  'stop_offers_for_worker_type',
  'uplifted_pay_rate',
  'offer_to',
  'offer_to_syft',
  'desc',
  'client_base_rate',
  'worker_base_rate',
  'rate_card_id',
  'workers_required',
  'agency_reported_demand_buffer',
]
